<template>
  <div>
    <div class="bg-white border shadow-lg p-4 lg:p-10 lg:w-9/12 mx-auto rounded-lg">
      <div class="mb-6 lg:mb-12 text-lg leading-relaxed">
        <p v-html="$t('preTraining.thank_you.content.p-1')" class="mb-6" />
        <p v-html="$t('preTraining.thank_you.content.p-2')" class="mb-6" />
        <p v-html="$t('preTraining.thank_you.content.p-3')" />
      </div>
      <div class="flex justify-center">
        <button @click="go" class="rounded-full button">
          {{ $t('preTraining.thank_you.button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    go() {
      return this.$router.push('/training');
    },
  },
  async mounted() {},
};
</script>
